import React from 'react'
import PropTypes from 'prop-types'

/**
 * Table foot component
 */
const TableFoot = ({ className = '', children, ...props }) => (
  <tfoot className={className} {...props}>
    {children}
  </tfoot>
)

TableFoot.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

TableFoot.defaultProps = {
  className: ''
}

export default TableFoot
